import api from "./api";
import axios from "axios";

// Logs user in
export const loginUser = (data) => {
  return api.post("/auth/login", data);
};

// Logs user out
export const logoutUser = () => {
  // No need to manually pass headers here! 
  // Your api.js interceptor automatically catches and attaches the token.
  return api.post("/auth/logout", {});
};

// ==========================================================
// USER MANAGEMENT ENDPOINTS (now routed through users.py at /api/users)
// ==========================================================

// Creates a new user (POST /api/users/add)
export const addUser = (userData) => {
  return api.post("/users/add", userData);
};

// Fetches all users from Flask db (GET /api/users/)
export const getAllUsers = () => {
  return api.get("/users/");
};

// Modifies existing user profile (PUT /api/users/<id>)
export const editUser = (userId, userData) => {
  return api.put(`/users/${userId}`, userData);
};

// Permanently purges user account (DELETE /api/users/<id>)
export const deleteUser = (userId) => {
  return api.delete(`/users/${userId}`);
};
export const getAccountManagerLeads = () => {
  return api.get("/leads/");
};
// --- Added Lead Detail Bindings ---
export const getLeadWorkspaceDetails = (leadId) => {
  return api.get(`/leads/${leadId}`);
};

export const addLeadNoteEntry = (leadId, noteData) => {
  return api.post(`/leads/${leadId}/notes`, noteData);
};

export const addLeadActivityLog = (leadId, activityData) => {
  return api.post(`/leads/${leadId}/activities`, activityData);
};

export const uploadLeadAttachmentFile = (leadId, formData) => {
  return api.post(`/leads/${leadId}/attachments`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const updateLeadWorkspaceDetails = (leadId, payload) => api.put(`/leads/${leadId}`, payload);
export const markLeadAsClosedStatus = (leadId) => api.patch(`/leads/${leadId}/close`);
export const deleteLeadWorkspaceRecord = (leadId) => api.delete(`/leads/${leadId}`);
export const updateLeadStageRoute = (leadId, stageName) => {
  return api.patch(`/leads/${leadId}/stage`, { stage_name: stageName });
};
// Add this export statement inside your existing frontend /api/auth.js structure
export const getLeadDropdownMetadata = () => {
  return api.get("/leads/meta-options");
};

// --- Deals ---
// Routed through the shared `api` instance (see ./api) so the same
// request/response interceptors that handle leads (auth header
// attachment + expired-token handling) apply here too.
export const getDealsList = () => {
  return api.get("/deals/list");
};
export const getBidInformation = (leadId) => {
  return api.get(`/leads/${leadId}/bid-information`);
};

export const saveBidInformationDraft = (leadId, formData) => {
  return api.post(
    `/leads/${leadId}/bid-information/save`,
    formData
  );
};

export const submitBidInformation = (leadId, formData) => {
  return api.post(
    `/leads/${leadId}/bid-information/submit`,
    formData
  );
};
export const changePassword = (payload) => api.post("/auth/change-password", payload);
 
// Login page "Forgot Password?" dialog - public, no auth needed.
export const forgotPassword = (email) => api.post("/auth/forgot-password", { email });
 
// Reset-password page, opened from the emailed link. The reset token is a
// short random value looked up server-side (see auth.py) - not a JWT - so
// it's sent as a normal field in the request body via the shared `api`
// instance, same as any other call.
export const resetPassword = (resetToken, newPassword, confirmPassword) =>
  api.post("/auth/reset-password", {
    token: resetToken,
    new_password: newPassword,
    confirm_password: confirmPassword,
  });